import { Suspense } from 'react';

import ErrorBoundary from './ErrorBoundary';

/**
 * BackgroundWidget — vỏ bọc cho TIỆN ÍCH NỀN mount toàn cục ở gốc app.
 *
 * Ba host (CNV Work SaaS, CNV Connect, Core) đều treo một dãy widget nền cạnh <Routes>:
 * softphone, thông báo chat, đăng ký web push, bảng lệnh Cmd+K, phím tắt chụp màn hình,
 * bộ dò bản mới… Trước nay mỗi cái chỉ được bọc `<Suspense fallback={null}>`.
 *
 * ⚠️ VÌ SAO PHẢI CÓ CÁI NÀY (02/09/2026):
 * `<Suspense>` chỉ đỡ lúc TẢI chunk, không đỡ lúc widget NÉM. Mà widget nền ném thì:
 *   - CNV Work SaaS + Connect: `Sentry.ErrorBoundary` bọc CẢ <App/> tóm được ⇒ thay TOÀN BỘ
 *     giao diện bằng trang "Đã có lỗi xảy ra".
 *   - Core: không có ErrorBoundary nào ở gốc ⇒ React gỡ sạch cây ⇒ TRẮNG TRANG.
 * Cả hai đều là: mất một thứ phụ trợ (mà đa số user còn không bật) → mất cả app.
 * Ca thật đã gặp: `FloatingCallWidget` gọi `useVoip()` bản NÉM, dev HMR nạp lại
 * VoipContext.jsx sinh instance context thứ hai ⇒ `useContext` trả null ⇒ ném.
 *
 * Hợp đồng: hỏng thì TẮT ĐÚNG NÓ, phần còn lại của app chạy tiếp; lỗi vẫn console.error +
 * bắn về Sentry với tag `boundary=<name>` (xem ErrorBoundary + lib/errorReporter).
 * Mỗi widget một vỏ RIÊNG — dùng chung một vỏ cho cả dãy thì một cái hỏng là tắt hết dãy.
 *
 * @param {{ name: string, children: React.ReactNode }} props
 *   name — tên ngắn để gom nhóm trên Sentry, vd 'voip' | 'web-push' | 'command-palette'.
 */
export default function BackgroundWidget({ name, children }) {
  return (
    <ErrorBoundary name={name} silent>
      <Suspense fallback={null}>{children}</Suspense>
    </ErrorBoundary>
  );
}
